package com.nonopn.skywatcher.common.app.navigation

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material.icons.Icons
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Modifier
import com.nonopn.icons.Logout
import com.nonopn.skywatcher.common.app.home.AppModel
import com.nonopn.skywatcher.common.app.home.LocalApp
import com.nonopn.skywatcher.common.app.home.LocalAppBarProvider
import com.nonopn.skywatcher.common.app.home.LocalThunderDetectionModel
import com.nonopn.skywatcher.common.app.pages.administrators.UsersContent
import com.nonopn.skywatcher.common.app.pages.sentinels.ThunderDetectionWithMetadata
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.appbar.AppBarStateProvider
import com.nonopn.skywatcher.design.widgets.MenuItem
import eu.codlab.navigation.NavBackStackEntryWrapper
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.Router
import kotlinx.serialization.Serializable

@Serializable
data class RouteUsers(
    val uuid: String,
) : RouteParameterSentinel {
    override fun uuid() = uuid
}

object RouterUsers : Router<RouteUsers>, RouterThunderDetectionSelected {
    override val klass = RouteUsers::class

    override fun route(navBackStackEntry: NavBackStackEntryWrapper) =
        RouteUsersImpl(navBackStackEntry.toRoute(klass))

    override fun isMatching(route: String) = null != extract(route)

    override fun navigateFrom(path: String) = RouteUsers(uuid = extract(path)!!)

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        routeParameterTo is RouteUsers

    fun navigateTo(thunderDetection: ThunderDetectionWithMetadata) =
        navigateTo(thunderDetection.detection.uuid)

    override fun navigateTo(uuid: String) = NavigateTo(
        route = RouteUsers(uuid = uuid),
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(
                launchSingleTop = true,
            )
        )
    )

    private fun extract(path: String): String? {
        val split = path.split("/")

        if (split.size < expectedSplitSize) {
            return null
        }

        if (split[indexUsers] != "users") {
            return null
        }

        if (split[indexSentinel] == "sentinel") {
            return split[indexUuid]
        }

        return null
    }

    private const val expectedSplitSize = 4
    private const val indexSentinel = 1
    private const val indexUuid = 2
    private const val indexUsers = 3
}

class RouteUsersImpl(params: RouteUsers) : Route<RouteUsers>(
    "/sentinel/{uuid}/users",
    params = params,
) {

    @Composable
    override fun scene() {
        val model = LocalThunderDetectionModel.current
        val selected = model.states.value.selectedThunderDetection

        if (selected.detection.uuid != params.uuid) return

        val provider = LocalApp.current
        val provider2 = LocalAppBarProvider.current
        LaunchedEffect(provider) {
            onInternalEntryIsActive(
                provider,
                provider2,
                selected,
                emptyList()
            )
        }

        UsersContent(Modifier.fillMaxSize(), selected)
    }

    private fun onInternalEntryIsActive(
        appModel: AppModel,
        model: AppBarStateProvider,
        thunderDetection: ThunderDetectionWithMetadata,
        defaultActions: List<MenuItem>
    ): String {
        model.setAppBarState(
            AppBarState.Regular(
                title = "Users",
                defaultActions + MenuItem.MenuItemSimple(
                    imageVector = Icons.Rounded.Logout,
                    onClick = {
                        appModel.selectThunderDetection(null)
                    }
                )
            )
        )

        return "/sentinel/${thunderDetection.detection.uuid}/users"
    }
}
